import * as React from 'react';
import './cardPaymentForm.module.scss';
import { observer } from 'mobx-react';
import { NewCardFormV2 } from './NewCardForm';
import { SplitMethodForm } from './SplitMethodForm';
import { CardSummaryView } from './CardSummaryView';
import type { CardPaymentState } from './states/CardPaymentState';

type Props = {
  state: CardPaymentState;
  priceWithoutTax: number;
  allowSplit?: boolean;
};

export const CardPaymentForm = observer(
  class CardPaymentForm extends React.Component<Props> {
    render() {
      const { state, priceWithoutTax, allowSplit = true } = this.props;
      const shouldShowNewForm = state.useNewCard || state.currentCard.isEmpty();
      return (
        <div styleName="payment-method-form">
          {shouldShowNewForm ? (
            <NewCardFormV2 state={state} />
          ) : (
            <CardSummaryView card={state.currentCard.get()} onModificationRequested={() => (state.useNewCard = true)} />
          )}
          {allowSplit && <SplitMethodForm state={state.splitMethodForm} priceWithoutTax={priceWithoutTax} />}
        </div>
      );
    }
  }
);
